import { Typography as MuiTypography, TypographyProps } from "@mui/material"

import { uiskMuiSpacingMap, UiskSpacingProps } from "../utils/uiskMuiSpacingMap"

const Typography = (
  props: Omit<TypographyProps, keyof UiskSpacingProps> & UiskSpacingProps,
) => {
  const muiSpacingProps = uiskMuiSpacingMap(props)
  return <MuiTypography {...props} {...muiSpacingProps} />
}

export default Typography
